import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { mediaSingleByEntityStateAndType } from '../atom';
import type { MediaEntityType, MediaType } from '../types';

/**
 * Get a single media item for a specific entity and media type
 * @param entityId - The entity ID
 * @param entityType - The entity type (e.g., 'USER', 'ORGANIZATION')
 * @param type - The media type (e.g., 'Avatar', 'Logo')
 * @returns The media item or undefined if not found
 *
 * @example
 * ```tsx
 * const { media } = useMediaByEntityAndType(userId, MediaEntityType.User, MediaType.Avatar);
 *
 * if (media) {
 *   return <img src={media.url.url} alt={media.name} />;
 * }
 * ```
 */
export const useMediaByEntityAndType = (
  entityId: string,
  entityType: MediaEntityType,
  type: MediaType
) => {
  const media = useAtomValue(
    useMemo(
      () => mediaSingleByEntityStateAndType(entityId, entityType, type),
      [entityId, entityType, type]
    )
  );

  return {
    media,
  };
};
